'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _AwayStatusIndicator = require('@/components/AwayStatusIndicator.vue');

var _AwayStatusIndicator2 = _interopRequireDefault(_AwayStatusIndicator);

var _BufferSettings = require('@/customized-core/BufferSettings.vue');

var _BufferSettings2 = _interopRequireDefault(_BufferSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'UserProfile',
	components: {
		AwayStatusIndicator: _AwayStatusIndicator2.default,
		BufferSettings: _BufferSettings2.default
	},
	props: {
		network: Object,
		buffer: {
			type: Object,
			required: true
		}
	},
	data: function data() {
		return {
			new_nick: '',
			error_message: '',
			isChangeNickFormOpen: false
		};
	},
	computed: {
		modeString: function modeString() {
			var str = '';
			this.network.ircClient.user.modes.forEach(function (mode) {
				str += mode;
			});

			if (str) {
				str = '+' + str;
			}

			return str;
		},
		netUser: function netUser() {
			return this.network.ircClient.user;
		},

		awayStatus: {
			get: function get() {
				return this.network.currentUser().away;
			},
			set: function set(val) {
				this.network.ircClient.raw('AWAY', val ? 'Currently away' : '');
			}
		}
	},
	created: function created() {
		var _this = this;

		this.listen(this.network.ircClient, 'nick in use', function (event) {
			_this.error_message = 'The nickname \'' + event.nick + '\' is already in use!';
		});
	},

	methods: {
		openSelfActions: function openSelfActions() {
			this.isChangeNickFormOpen = true;
		},
		closeSelfUser: function closeSelfUser() {
			this.$emit('close');
		},
		changeNick: function changeNick() {
			var nick = this.new_nick.trim();
			if (nick.length === 0) {
				this.error_message = 'You must enter a new username';
				return;
			}
			if (nick.match(/(^[0-9])|(\s)/)) {
				this.error_message = 'Username must not start with a number';
				return;
			}
			this.error_message = '';
			this.network.ircClient.changeNick(nick);
			this.userNameCancel();
		},
		userNameCancel: function userNameCancel() {
			this.isChangeNickFormOpen = false;
		},
		networkSupportsAway: function networkSupportsAway() {
			return this.network.ircClient.network.cap.isEnabled('away-notify');
		},
		checkUserAway: function checkUserAway() {
			return !!this.network.currentUser().away;
		},
		getUserFromString: function getUserFromString(name) {
			return this.$state.getUser(this.network.id, name);
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/UserProfile.vue
// module id = 62nC
// module chunks = 1